module.exports = __webpack_public_path__ + "static/media/fin2.91fb027f.jpg";